import { Collapsible } from "./Collapsible";
import type { CollapsibleProps } from "./Collapsible.d";

export { Collapsible };
export type { CollapsibleProps };
